export const SHOW_DIALOGS_SETTINGS = 'SHOW_DIALOGS_SETTINGS'
export const HIDE_DIALOGS_SETTINGS = 'HIDE_DIALOGS_SETTINGS'

export const FETCH_DIALOGS_SETTINGS_REQUEST = 'FETCH_DIALOGS_SETTINGS_REQUEST'
export const FETCH_DIALOGS_SETTINGS_SUCCESS = 'FETCH_DIALOGS_SETTINGS_SUCCESS'
export const FETCH_DIALOGS_SETTINGS_FAILURE = 'FETCH_DIALOGS_SETTINGS_FAILURE'

export const UPDATE_PHRASES_REQUEST = 'UPDATE_PHRASES_REQUEST'
export const UPDATE_PHRASES_SUCCESS = 'UPDATE_PHRASES_SUCCESS'
export const UPDATE_PHRASES_FAILURE = 'UPDATE_PHRASES_FAILURE'

export const UPDATE_GREETING_REQUEST = 'UPDATE_GREETING_REQUEST'
export const UPDATE_GREETING_SUCCESS = 'UPDATE_GREETING_SUCCESS'
export const UPDATE_GREETING_FAILURE = 'UPDATE_GREETING_FAILURE'

export const RESET_DIALOGS_UPDATED_STATE = 'RESET_DIALOGS_UPDATED_STATE'
